$(document).ready(function () {

    /**
     * Align Height
     */

    function alignHeight(selector) {
        jQuery(selector).css('height', '');
        var minHeight = 0;
        jQuery(selector).each(function () {
            if (minHeight < jQuery(this).outerHeight()) {
                minHeight = jQuery(this).outerHeight();
            }
        });
        if (minHeight > 0) {
            jQuery(selector).css('height', minHeight);
        }
    }

    /**
     * Validate checkbox footer
     */

    if ($('#check_submitting').length) {
        $('#check_submitting').on('click', function () {
            if ($(this).is(':checked')) {
                $('.footer__item-padding').find('.footer__newsletter-btn').attr("disabled", false);
            } else {
                $('.footer__item-padding').find('.footer__newsletter-btn').attr("disabled", true);
            }
        });
    }

    /**
     * Product accordion description
     */

    $('.accordion__header').click(function (e) {
        e.preventDefault();
        var currentIsActive = $(this).hasClass('is-active');
        $(this).parent('.accordion').find('> *').removeClass('is-active');
        if (currentIsActive != 1) {
            $(this).addClass('is-active');
            $(this).next('.accordion__body').addClass('is-active');
        }
    });

    /**
     * Recommendations Product
     */

    $(".content_page .off_angels").on('click', function() {
        $('#NewsletterPopup-newsletter-popup').addClass('modal--is-active');
        $('html').addClass('modal-open');
    });

    $('.js-modal-close').on('click', function() {
        $(this).closest('#NewsletterPopup-newsletter-popup').removeClass('modal--is-active');
        $('html').removeClass('modal-open')
    });

    var load_recently_view = setInterval(function () {
        if ($('.main-carousel').length) {
            // $('.main-carousel').slick({
            //     infinite: false,
            //     speed: 1000,
            //     slidesToShow: 4.15,
            //     slidesToScroll: 1,
            //     arrows: false,
            //     dots: true,
            //     responsive: [{
            //         breakpoint: 1025,
            //         settings: {
            //             slidesToShow: 3.15,
            //             slidesToScroll: 1,
            //             infinite: false,
            //         }
            //     },
            //         {
            //             breakpoint: 768,
            //             settings: {
            //                 slidesToShow: 2.15,
            //                 slidesToScroll: 1,
            //                 infinite: false,
            //             }
            //         }
            //     ]
            // });

            alignHeight('.grid-product__meta .grid-product__title');
            alignHeight('.brand_product p');
            alignHeight('.collection-content .star_okendo');
            $("form.RecommendationsForm__AddToCart").click(function(){
                $(this).parent().find('.grid-product__content .quick-product__btn').trigger('click');
            });
            clearInterval(load_recently_view);
        }else {
            $("form.RecommendationsForm__AddToCart").click(function(){
                $(this).parent().find('.grid-product__content .quick-product__btn').trigger('click');
            });
            clearInterval(load_recently_view);
        }
    }, 1000);

    var load_image_product = setInterval(function () {
        if ($('.template-product .product-slideshow-mobile').length) {
            $('.template-product .product-slideshow-mobile').slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '20%',
                autoplay: true,
                speed: 1000,
                pauseOnHover: false,
            });
            clearInterval(load_image_product);
        }
    }, 1000);

    $(window).on('load resize scroll', function () {
        setTimeout(function () {
            alignHeight('.grid-product__meta .grid-product__title');
            alignHeight('.brand_product p');
            alignHeight('.collection-content .star_okendo');
            alignHeight('.grid-product__meta');
            alignHeight('.popup-kol-block .popup-list .popup-item .content');
            alignHeight('.template-index .text-with-images .grid--flush-bottom .grid__item');

        }, 100);
    });

    /**
     * Product sticky block Add to cart
     */

    if ($(window).width() < 768 && $('body').hasClass('template-product')) {
        var load_element = 0;
        //position of element
        var scroll_position = jQuery('.block_add_to_cart').offset().top;
        var screen_height = jQuery(window).height();
        var activation_offset = 0;
        var max_scroll_height = jQuery('body').height() + screen_height;
        var scroll_activation_point = scroll_position - (screen_height * activation_offset);

        jQuery(window).on('scroll', function (e) {

            var y_scroll_pos = window.pageYOffset;
            var element_in_view = y_scroll_pos > scroll_activation_point;
            var has_reached_bottom_of_page = max_scroll_height < y_scroll_pos && !element_in_view;

            if (element_in_view || has_reached_bottom_of_page) {
                $('body').addClass('sticky-add-cart');

            } else {
                $('body').removeClass('sticky-add-cart');
            }
        });
    }

    /**
     * Close Off Euna Angles
     */

    $('.off_angels .close').click(function (e) {
        $(this).parent().addClass('close_angles');
    });

    /**
     * Active filter collections
     */
    $('.collection-content .tag').click(function () {
        $(this).closest('.collection-content').addClass("active_filter");
    });

    $(window).on('load resize', function () {
        if ($('.collection-content .tag').hasClass('tag--remove')) {
            $('.collection-content').addClass("active_filter");
        }
        if($(window).width() < 768) {
            $('.template-index .text-with-images .grid--flush-bottom').not('.slick-initialized').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                dots: true,
                autoplay: false,
            })
        }
    });


    $('.fillter-desktop').on('click', function () {
        $(this).parent().addClass('active-filter-desktop');
    })

    /**
     * Clear all filter
     */
    $(document).on('click', '#clear_all_filter', function () {
        var url = window.location.href.match(/^[^\#\?]+/)[0];
        window.location.href = url;
        $(this).parent().removeClass('active-filter-desktop');
    });

    $('.page-width.kol-section .content-block > .right .item').click(function () {
       $('.popup-kol-block').addClass("active");
    });

    $('.popup-kol-block .popup-list').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        dots: false,
        autoplay: false,
    });

    $('.popup-kol-block .content-popup .close, .popup-kol-block').click(function () {
        $('.popup-kol-block').removeClass("active");
    })

    $(".content-popup").click(function(e){
        e.stopPropagation();
    });

    document.addEventListener('cart:updated', function(evt) {
        console.log('updated');
    });

    document.addEventListener('ajaxProduct:added', function(evt) {
        console.log('added');
    });
});
